module.exports = __webpack_public_path__ + "static/media/scale.0b2d21f3.svg";